import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Table, Input, Label, Alert } from 'reactstrap'
import { enterKeyHandler } from '../../utils'
import useForm from '../CustomHooks/FormHook'
import './Custom.css'
import { initialFormValues, submitFormValues } from './CustomUtils'
import FormHeading from './FormHeading'
import FormSubmitButton from './FormSubmitButton'

export default function SingleFieldSearchForm({ location }) {
  console.log('SingleFieldSearchForm rendered: ', location)
  const reportType = location.pathname.split('/')[2]

  const pathName = location.pathname.substr(location.pathname.lastIndexOf('/') + 1)
  let init = {
    searchTerm: '',
    orderBy: '1',
    orderDir: 'ASC',
    pathName: pathName
  }

  const navigate = useNavigate()
  init = initialFormValues(`${reportType}`, navigate, init)
  const { inputs, handleInputChange, handleSubmit } = useForm(init, submitSearch, enterKeyHandler(submitSearch))
  const [formFeedback, setFormFeedback] = useState()

  async function submitSearch() {
    console.log('SingleFieldSearchForm.submitSearch', inputs)

    const validInput = inputs.searchTerm ? true : false

    if (!validInput) {
      return setFormFeedback(<tr><td colSpan={2}><Alert className='custom-alert' color='danger' style={{width: 'fit-content', textAlign: 'center', margin: 'auto', marginBottom: '5px'}}>There can not be an empty search.</Alert></td></tr>)
    }

    submitFormValues(`${reportType}`, navigate, inputs, `${reportType}`)
  }

  return (
    <div className="custom-scroll">
      <form onSubmit={handleSubmit}>
        <div>
          <Table className="custom-table custom-form-table" style={{backgroundColor: 'white'}}>
            <FormHeading headingText='Index Item Search' />
            <tbody>
              {formFeedback}
              <tr>
                <td><Label><b>Find</b></Label></td>
                <td><Input className="custom-input" name='searchTerm' onChange={handleInputChange} defaultValue={inputs.searchTerm} /></td>
              </tr>
            </tbody>
          </Table>
        </div>
        <FormSubmitButton label="Search" />
      </form>
    </div >
  )
}